import { createUseMutationHook } from './createUseMutationHook';

export const useDeleteService = createUseMutationHook(
    'service_delete',
    () => ['person_trip_detail'],
);
